import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export const ReturnType = ({ returnOrder }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Return Type: {returnOrder.dropOff === "Yes" ? "Drop-off" : "Collection"}
      </Typography>
      {returnOrder.dropOff === "Yes" ? (
        <Typography>
          Drop off has been selected. You will be sent instructions how and
          where to drop off the return.
        </Typography>
      ) : (
        <Typography>
          Collection has been selected. Our courrier will come to you and a
          label will be provided by the driver.
        </Typography>
      )}
    </Paper>
  );
};
